import React from 'react';

const LandingPrimaryText = ({children, additionalclasses}) => {
    return (
        <p className={`lg:text-[20px] text-[16px] leading-[26px] text-white-50 text-center ${additionalclasses}`}>{children}</p>
    );
};

export default LandingPrimaryText;